import { render, staticRenderFns } from "./gc-popup-distribution-manifest-add-order.vue?vue&type=template&id=d51e5028"
import script from "./gc-popup-distribution-manifest-add-order.vue?vue&type=script&lang=js"
export * from "./gc-popup-distribution-manifest-add-order.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-distribution-manifest-add-order.vue?vue&type=style&index=0&id=d51e5028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports